import React, { useMemo } from 'react';
import { Box, useToken } from '@chakra-ui/react';

type TopoBackdropProps = {
  fade?: boolean;
};

const TopoBackdrop = ({ fade = false }: TopoBackdropProps) => {
  const [accent, success] = useToken('colors', ['brand.primary', 'brand.secondary']);

  const fadeMask = fade
    ? 'linear-gradient(to bottom, rgba(0,0,0,1) 0px, rgba(0,0,0,1) 260px, rgba(0,0,0,0) 720px)'
    : undefined;

  const lines = useMemo(() => {
    const count = 9;
    return Array.from({ length: count }, (_, i) => {
      const y = 80 + i * 90;
      const amp = 30 + (i % 3) * 12;
      const phase = (i * 47) % 200;
      const d = `M -50 ${y} Q ${300 + phase} ${y - amp} ${700} ${y} T ${1450} ${y}`;
      const stroke = i % 3 === 1 ? success : accent;
      const strokeWidth = i % 4 === 0 ? 1.4 : 0.9;
      const opacity = 0.16 + (i % 3) * 0.04;
      return (
        <path
          key={i}
          d={d}
          stroke={stroke}
          strokeWidth={strokeWidth}
          fill="none"
          opacity={opacity}
        />
      );
    });
  }, [accent, success]);

  return (
    <Box
      position="absolute"
      inset={0}
      pointerEvents="none"
      zIndex={0}
      aria-hidden="true"
      overflow="hidden"
      sx={fadeMask ? { maskImage: fadeMask, WebkitMaskImage: fadeMask } : undefined}
    >
      <svg
        viewBox="0 0 1400 1000"
        preserveAspectRatio="xMidYMid slice"
        width="100%"
        height="100%"
        style={{ display: 'block' }}
      >
        <defs>
          <radialGradient id="topoGlow" cx="50%" cy="30%" r="60%">
            <stop offset="0%" stopColor={accent} stopOpacity="0.08" />
            <stop offset="100%" stopColor={accent} stopOpacity="0" />
          </radialGradient>
        </defs>
        <rect width="1400" height="1000" fill="url(#topoGlow)" />
        {lines}
      </svg>
    </Box>
  );
};

export default TopoBackdrop;
